// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"17":"cd03a578","254":"7904bebe"}[chunkId] + ".chunk.css";
};